// Stop the "shows, then reloads" flash on pages built as a shell plus an
// eager turbo-frame (Messages, Network, Calendar, Wire, Jobs, Activity).
//
// Revisiting one of those pages, Turbo Drive first paints its cached snapshot
// as a preview, list and all. When the fresh shell arrives it replaces the
// body, and the frame in it is back to its loading skeleton, so the list the
// reader was already looking at vanishes until /…/list answers and paints it a
// second time.
//
// Before the fresh shell renders, carry the content of each loaded frame on
// screen into the matching frame of the new body. The frame still fetches its
// src as it always did and swaps the fresh content in place, so the reader sees
// the cached list, then the current one, with no skeleton in between.
//
// Only for frames whose src is identical (a different filter or page is
// different content, and keeps its skeleton), only into frames the server sent
// unloaded (a snapshot restored from the cache already has its own content),
// and only from frames that finished loading.
const absoluteSrc = (frame) => {
    const src = frame.getAttribute("src")
    return src ? new URL(src, document.baseURI).href : null
}

document.addEventListener("turbo:before-render", (event) => {
    const newBody = event.detail.newBody
    if (!newBody) return

    newBody.querySelectorAll("turbo-frame[id][src]:not([complete])").forEach((incoming) => {
        const current = document.getElementById(incoming.id)
        if (!current || current.tagName !== "TURBO-FRAME" || !current.hasAttribute("complete")) return
        if (absoluteSrc(current) !== absoluteSrc(incoming)) return
        if (!current.hasChildNodes()) return

        incoming.replaceChildren(...current.childNodes)
    })
})
